import { render, staticRenderFns } from "./ResponsiveContainer.vue?vue&type=template&id=32c9bb36&"
import script from "./ResponsiveContainer.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
